<template>
  <div>
    <brazilian-currency-input
      v-if="isSubtipoMoeda"
      :filled="filled"
      :disabled="disabled"
      :readonly="readonly"
      :mostrar-icones="mostrarIcones"
      :obrigatorio="obrigatorio"
      :label="label"
      :value="brazilianCurrencyValue"
      :rules="rules"
      :is-configurar-celula-dialog-open="isConfigurarCelulaDialogOpen"
      :is-deletar-componente-dialog-open="isDeletarComponenteDialogOpen"
      @update:is-configurar-celula-dialog-open="v => $emit('update:is-configurar-celula-dialog-open', v)"
      @update:is-deletar-componente-dialog-open="v => $emit('update:is-deletar-componente-dialog-open', v)"
      @input-changed="$emit('input-changed', { value: $event })"
    />

    <v-text-field
      v-else
      v-model="valueTextLocale"
      v-mask="`${ subtipoMask }`"
      dense
      outlined
      hide-details
      validate-on-blur
      :label="label"
      :filled="filled"
      :disabled="disabled"
      :readonly="readonly"
      :rules="rules"
      @change="$emit('input-changed', { value: $event })"
    >
      <template
        v-if="mostrarIcones"
        v-slot:prepend
      >
        <icons
          :is-configurar-celula-dialog-open="isConfigurarCelulaDialogOpen"
          :is-deletar-componente-dialog-open="isDeletarComponenteDialogOpen"
          @update:is-configurar-celula-dialog-open="v => $emit('update:is-configurar-celula-dialog-open', v)"
          @update:is-deletar-componente-dialog-open="v => $emit('update:is-deletar-componente-dialog-open', v)"
        />
      </template>
    </v-text-field>
  </div>
</template>

<script>
import { computed, ref, watchEffect } from '@vue/composition-api'
import { required } from '@core/utils/validation'
import Icons from './Icons.vue'
import ComponenteBase from './ComponenteBase.vue'
import ComponenteNumericoSubtiposEnum from '@/models/entities/formulario/componente/ComponenteNumericoSubtiposEnum'
import BrazilianCurrencyInput from '@/views/formulario/subcomponentes/BrazilianCurrencyInput.vue'
import textComponentMixin from '@/mixins/textComponentMixin'
import { parseStringAsFloat } from '@/utils/numbers'

export default {
  components: {
    Icons,
    BrazilianCurrencyInput,
  },

  extends: ComponenteBase,

  mixins: [textComponentMixin],

  props: {
    componenteNumericoSubtipoId: {
      type: Number,
      required: true,
    },
    regex1: {
      type: String,
      required: true,
    },
    regex2: {
      type: String,
      default: null,
    },
  },

  setup(props) {
    const isSubtipoMoeda = computed(() => props.componenteNumericoSubtipoId === ComponenteNumericoSubtiposEnum.MoedaId)
    const isRequired = computed(() => (props.obrigatorio && !props.readonly ? required : true))

    const rules = computed(() => [isRequired.value, v => new RegExp(props.regex1).test(v)])

    const subtipoMask = computed(() => {
      switch (props.componenteNumericoSubtipoId) {
        case ComponenteNumericoSubtiposEnum.DataId:
          return '##/##/####'
        case ComponenteNumericoSubtiposEnum.HorarioId:
          return '##:##'
        case ComponenteNumericoSubtiposEnum.CepId:
          return '#####-###'
        case ComponenteNumericoSubtiposEnum.CpfId:
          return '###.###.###-##'
        case ComponenteNumericoSubtiposEnum.CnpjId:
          return '##.###.###/####-##'
        case ComponenteNumericoSubtiposEnum.TelefoneId:
          return '(##) #####-####'
        case ComponenteNumericoSubtiposEnum.NumeroSimplesId:
          return '##########'
        default:
          return null
      }
    })

    const valueTextLocale = ref(null)
    watchEffect(() => { valueTextLocale.value = props.valueText })

    const brazilianCurrencyValue = ref(null)
    watchEffect(() => { brazilianCurrencyValue.value = parseStringAsFloat(props.valueText) })

    return {
      isRequired,
      rules,
      isSubtipoMoeda,
      subtipoMask,
      valueTextLocale,
      brazilianCurrencyValue,
    }
  },
}
</script>
